<script>
import { UsersApi } from '@/api/resources/UsersApi'
import UsersModalUploadPermissionsFile from './UsersModalUploadPermissionsFile.vue'


export default {
  name: 'UsersActivityModalUploadUsersFile',
  extends: UsersModalUploadPermissionsFile,
  props: {
    title: {
      type: String,
      default: 'Обновление активности пользователей',
    },
    request: {
      type: Function,
      default: (...args) => {
        const api = new UsersApi()
        return api.importUsersActivities(...args)
      },
    },
    fileTemplateUrl: {
      type: String,
      default: '/files/users_activity.xlsx',
    },
  },
}
</script>
